import { memo } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { formatNumber } from '@bonanza-social/toolkit/utils';
import { Box, Text } from '@bonanza-social/moonlight';
import { PrizeWallPrizeQuantityProps } from './PrizeWallPrizeQuantity.types';

function PrizeWallPrizeQuantity({
  light,
  totalQuantity,
  remainingQuantity,
  quantityFormat,
  ...rest
}: PrizeWallPrizeQuantityProps) {
  const [t] = useTranslation('prizeWall');

  return (
    <Box
      alignSelf="flex-start"
      borderRadius="radius-full"
      paddingVertical="space-050"
      paddingHorizontal="space-100"
      overflow="hidden"
      centerContent
      {...(light
        ? { variant: 'gradient' }
        : { backgroundColor: 'primaryBackgroundHover' })}
      {...rest}
    >
      <Text
        variant="badge"
        color={light ? 'accentSurfacePrimary' : 'darkSurfacePrimary'}
      >
        {t('prizeWallPrizeQuantity', {
          totalQuantity: formatNumber(totalQuantity),
          remainingQuantity: formatNumber(remainingQuantity),
          context: quantityFormat,
        })}
      </Text>
    </Box>
  );
}

export default memo(PrizeWallPrizeQuantity);
